import React from 'react'
import Headers from '../components/Headers'
import Footer from '../components/Footer'

const TermsAndConditions = () => {
    return (
        <div className='w-full'>
            <Headers />
            <div className='w-[85%] mx-auto py-16'>
                <div className='bg-white dark:bg-gray-900 rounded-lg p-8'>
                    <h1 className='text-3xl font-bold mb-6 text-gray-900 dark:text-white'>Terms and Conditions</h1>
                    
                    <div className='prose dark:prose-invert max-w-none'>
                        <p className='mb-4 text-gray-700 dark:text-gray-300'>
                            <strong>Last updated:</strong> {new Date().toLocaleDateString()}
                        </p>

                        <h2 className='text-xl font-semibold mb-4'>Acceptance of Terms</h2>
                        <p className='mb-4 text-gray-700 dark:text-gray-300'>
                            By accessing and using Omah Global, you accept and agree to be bound by the terms and provision
                            of this agreement. These Terms and Conditions apply to all users of the platform.
                        </p>

                        <h2 className='text-xl font-semibold mb-4'>Account Registration</h2>
                        <ul className='list-disc pl-6 mb-4 text-gray-700 dark:text-gray-300'>
                            <li>You must be at least 18 years old to create an account</li>
                            <li>You are responsible for maintaining the confidentiality of your account credentials</li>
                            <li>You agree to provide accurate and complete information during registration</li>
                            <li>You are responsible for all activities that occur under your account</li>
                        </ul>

                        <h2 className='text-xl font-semibold mb-4'>Use of the Platform</h2>
                        <p className='mb-4 text-gray-700 dark:text-gray-300'>
                            You agree to use Omah Global only for lawful purposes and in accordance with these Terms.
                            You may not use the platform to sell prohibited items, engage in fraudulent activities, 
                            or violate any applicable laws or regulations.
                        </p>

                        <h2 className='text-xl font-semibold mb-4'>Seller Obligations</h2>
                        <ul className='list-disc pl-6 mb-4 text-gray-700 dark:text-gray-300'>
                            <li>Provide accurate product descriptions and images</li>
                            <li>Fulfill orders promptly and as described</li>
                            <li>Respond to customer inquiries in a timely manner</li>
                            <li>Comply with all applicable laws and regulations</li>
                            <li>Pay applicable fees and commissions</li>
                        </ul>

                        <h2 className='text-xl font-semibold mb-4'>Payment and Fees</h2>
                        <p className='mb-4 text-gray-700 dark:text-gray-300'>
                            All prices are displayed in the applicable currency and include applicable taxes. 
                            Payment processing fees and seller commission rates are disclosed during the checkout process.
                        </p>

                        <h2 className='text-xl font-semibold mb-4'>Limitation of Liability</h2>
                        <p className='mb-4 text-gray-700 dark:text-gray-300'>
                            Omah Global shall not be liable for any indirect, incidental, special, or consequential damages
                            resulting from the use of our platform. Our liability is limited to the maximum extent permitted by law.
                        </p>

                        <h2 className='text-xl font-semibold mb-4'>Modifications to Terms</h2>
                        <p className='mb-4 text-gray-700 dark:text-gray-300'>
                            We reserve the right to modify these Terms and Conditions at any time. Changes will be effective 
                            immediately upon posting on the platform. Your continued use constitutes acceptance of the modified terms.
                        </p>

                        <h2 className='text-xl font-semibold mb-4'>Contact Information</h2>
                        <p className='text-gray-700 dark:text-gray-300'>
                            For questions regarding these Terms and Conditions, please contact us at support@omaglobal.com.
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default TermsAndConditions
